import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useBrand() {
  const [brand, setBrand] = useState(cache);
  useEffect(() => {
    if (cache) { setBrand(cache); return; }
    api.get("/public/site").then((r) => {
      const s = r.data.settings || {};
      cache = { ...s, ...(s.brand || {}), seo: s.seo || {} };
      setBrand(cache);
    }).catch(() => {});
  }, []);
  return brand || {};
}
